import React from 'react';
import {
  Field,
  SitecoreContext,
  withSitecoreContext,
  LinkFieldValue,
  WithSitecoreContextProps,
} from '@sitecore-jss/sitecore-jss-react';
import { Link } from 'react-router-dom';

import './index.scss';
import { SearchBox } from '../Coveo/search-box';
import { searchBox } from '../Coveo/search-controllers';
import { Button } from '@mui/material';
import { TRAINING_IDENTIFIER_COVEO } from '../../utils/constants';

export type SearchFieldProps = WithSitecoreContextProps & {
  fields: {
    PlaceholderText: Field<string>;
    ResultsPage: Field<LinkFieldValue>;
    DisplaySearchedQuery: Field<boolean>;
    IsMobileHeaderSearch: Field<boolean>;
    IsPageSearch: Field<boolean>;
    BrowseStatisticsReportText: Field<string>;
    BrowseTrainingText: Field<string>;
    SearchInfoText: Field<string>;
  };

  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

export const SearchField = ({ fields, sitecoreContext }: SearchFieldProps): React.JSX.Element => {
  if (fields) {
    return (
      <>
        <div className="site-search site-search-border">
          {sitecoreContext.pageEditing && (
            <>
              <p>SearchField Component Edit Mode</p>
            </>
          )}
          <div className="full-width-helper">
            <div className="site-search-frame">
              <div className="site-search-form-wrapper">
                <SearchBox
                  controller={searchBox}
                  fields={{
                    'Popup Text': fields.SearchInfoText,
                  }}
                />
                <div className="browse-button-div">
                  <Link to="/standards" id="Search" className="browseAllLink">
                    <Button className="ws-primary-button-no-border browse" variant="contained">
                      BROWSE ALL
                    </Button>
                  </Link>
                  <Link
                    to="/standards#f-producttype=StatisticsReport"
                    id="search-statistics-report"
                    className="browseAllLink"
                  >
                    <Button className="ws-primary-button-no-border browse" variant="contained">
                      {fields.BrowseStatisticsReportText?.value}
                    </Button>
                  </Link>
                  <Link
                    to={`/standards#f-producttype=${TRAINING_IDENTIFIER_COVEO}`}
                    className="browseAllLink"
                  >
                    <Button className="ws-primary-button-no-border browse" variant="contained">
                      {fields.BrowseTrainingText?.value}
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else if (!fields && sitecoreContext.pageEditing) {
    return <p>Please setup the Datasource.</p>;
  }
  return <></>;
};

export default withSitecoreContext()(SearchField);
